import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./MobileApp.scss";

export const MobileFAQ = () => {
  return (
    <div className="mobileFAQ__root">
      <header className="mobileFAQ__hero">
        <h1 className="mobileFAQ__title">Frequently asked questions</h1>
        <p className="mobileFAQ__subtitle">
          Scoring, leagues and your account — all in one place.
        </p>
      </header>

      <div className="mobileFAQ__list">
        {rules.map(({ header, description }) => (
          <Accordion
            key={`${header} - accordionFAQ`}
            disableGutters
            elevation={0}
            className="mobileFAQ__accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="mobileFAQ__expandIcon" />}
              aria-controls={`${header}-content`}
              id={`${header}-header`}
              className="mobileFAQ__summary"
            >
              <span className="mobileFAQ__question">{header}</span>
            </AccordionSummary>
            <AccordionDetails className="mobileFAQ__details">
              {description}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

const rules = [
  {
    header: "How to score points?",
    description: (
      <Typography>
        In order to get points, users must bet on matches. Bets must be created
        before the match starts, otherwise the user loses the chance to bet on
        the match.
      </Typography>
    ),
  },
  {
    header: "How to win league?",
    description: (
      <Typography>
        To win the league you need to gather the highest amount of points in
        specific league.
      </Typography>
    ),
  },
  {
    header: "How many points I receive for correct bet?",
    description: (
      <Typography>
        Player receives 2 points for betting a correct match outcome or 4 points
        for betting the exact score. In the knockout stage points increase with
        every round. <br /> <br />
        Round of 32 - 3pts/6pts <br /> Round of 16 - 4pts/8pts <br />
        Quarter-finals - 5pts/10pts <br /> Semi-finals - 6pts/12pts <br />
        Third-place play-off - 6pts/12pts <br /> Final - 7pts/14pts
      </Typography>
    ),
  },
  {
    header: "Which score should I bet in Knockout Stage?",
    description: (
      <Typography>
        In Knockout Stage we take into consideration only the result from
        standard time (90min).
      </Typography>
    ),
  },
  {
    header: "Who can manage a league?",
    description: (
      <Typography>
        The founder of a league might be the only administrator of league.,
      </Typography>
    ),
  },
  {
    header: "What if I forget my password?",
    description:
      "Contact support at gacek.filip12@gmail.com, after that your password should be reset.",
  },
  {
    header: "What if two user have equal amount of points?",
    description:
      "The place in the ranking is determined by the number of Pefect Bets. More Perfect Bets - Higher place in the ranking",
  },
];
